import { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'
import { useTrackingContext } from '../../../../../providers/tracking'
import { saveCity } from '../../../../../actions/buyerOnboarding'
import { useWizardProvider } from '../../../../shared/WizardContext'
import { FROM } from '../../../../../mappings/navigation'
import { selectWelcomeBack, selectClientFirstName } from '../../../../../store/selectors/client'
import Logo from '../../../../shared/Logo'
import { Text, Unless } from '../../../..'
import { CityCopy } from './CityCopy'
import { selectCreateClientFrom } from '../../../../../store/slices/navigation'
import { GoogleAutoComplete } from 'src/Components/homeSearch/GoogleAutoComplete/GoogleAutoComplete'

import styles from './EnterCity.module.scss'

const { SOLO_BUYER } = FROM

export const EnterCity = () => {
  const dispatch = useDispatch()
  const { goForward } = useWizardProvider()
  const { trackingClient } = useTrackingContext()
  const [placeDetails, setPlaceDetails] = useState<google.maps.places.PlaceResult>()
  const from = useSelector(selectCreateClientFrom) || SOLO_BUYER
  const welcomeBack = useSelector(selectWelcomeBack)
  const firstName = useSelector(selectClientFirstName)

  const handleCity = place => {
    trackingClient?.buyerOnboarded({ city: place.description })
  }

  useEffect(() => {
    if (placeDetails) {
      const city = {
        name: placeDetails?.formatted_address,
        lon: placeDetails?.geometry?.location?.lng(),
        lat: placeDetails?.geometry?.location?.lat()
      }

      dispatch(saveCity(city))

      // @ts-ignore
      goForward()
    }
  }, [placeDetails])

  return (
    <div data-qa='enter-city' className={styles.step}>
      <Logo className={styles.logo} />
      <Unless condition={welcomeBack}>
        <Text size='xs' variant='neutralCool' variantCount='600' transform='uppercase'>
          <FormattedMessage
            id='NewBuyerOnboarding.cityStep.salutation'
            defaultMessage='Welcome, {firstName}!'
            values={{ firstName }}
          />
        </Text>
      </Unless>
      <CityCopy from={from} welcomeBack={welcomeBack} name={firstName} />
      <form data-qa='enter-city'>
        <Text size='l' variant='neutralCool' variantCount='900' className={styles.label}>
          <FormattedMessage
            id='NewBuyerOnboarding.cityStep.inputHeadline'
            defaultMessage='Where are you house hunting?'
          />
        </Text>
        <GoogleAutoComplete
          types={['locality', 'postal_code']}
          showFullModal={false}
          onPlaceSelected={handleCity}
          setPlaceDetails={setPlaceDetails}
        />
      </form>
    </div>
  )
}
